module.exports = __webpack_public_path__ + "img/item_mortal_city_tip.db053589.png";